import { Accordion, AccordionTypes, Text, VStack } from '@genial/components';
import { BoxBorder } from '@genial/design-tokens';
import { useBreakpointValue } from '@genial/utils';
import { Box, Pressable } from 'native-base';
import React, { useState } from 'react';

interface InfoResponsiveContainerProps {
  title: string;
  children: React.ReactNode;
}

export const InfoResponsiveContainer: React.FC<InfoResponsiveContainerProps> = ({
  children,
  title,
}) => {
  const isMobile = useBreakpointValue({ base: true, sm: false });
  const [accordionState, setAccordionState] = useState<AccordionTypes.Status>('closed');

  const handlePress = async () => {
    setAccordionState((prevState) => (prevState === 'closed' ? 'opened' : 'closed'));
  };

  if (isMobile) {
    return (
      <Accordion
        testId="alerts-info"
        status={accordionState}
        onPress={handlePress}
        hasShadow={false}
        containerProps={{ bg: 'neutral.white', p: 'inline.xxxs', flex: 1, w: 'full' }}
        forceDesktopLayout>
        <Accordion.Visible w="full" flex={1}>
          <Pressable onPress={handlePress}>
            <Text variant="semibold" fontSize="md">
              {title}
            </Text>
          </Pressable>
        </Accordion.Visible>
        <Accordion.Expanded forceDesktopLayout>{children}</Accordion.Expanded>
      </Accordion>
    );
  }

  return (
    <VStack
      bg="neutral.white"
      space="stack.xxxs"
      borderWidth={1}
      borderColor="neutral.lightest"
      borderRadius={BoxBorder.heavy}
      p="inset.sm">
      <Text variant="semibold" fontSize="lg" color="neutral.darkest">
        {title}
      </Text>
      <Box width="full" borderTopWidth={1} borderColor="neutral.lightest" />
      {children}
    </VStack>
  );
};
